<template>
    <div class="table-list biz-task-finished">
        <modal class="delete-task" :display="modalStatus.deleteTask" @modalStatus="modalStatus.deleteTask = false" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除委託</h1>
            <div class="content">
                確定刪除 ”{{taskHouseName}}”結束的委託嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteTask(), $analyticsBiz.logEvent('送出刪除委託', { screen_name: '送出刪除委託'})">確認</button>
                <button class="border-button" @click="modalStatus.deleteTask = false">取消</button>
            </div>
        </modal>
        <view-house-detail  :key="'houseDetail'+componentKey" :task="taskId" :tasker="takerName"></view-house-detail>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="cover">房源圖片</span>
            <span class="task-date">委託時間</span>
            <span class="house">房源名稱</span>
            <span class="name">受託人</span>
            <span class="pay-way">付款方式</span>
            <span class="status">狀態</span>
            <span class="bonus">委託獎金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="taskFinishedList.length != 0 && this.filterByWord == 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <div v-else-if="taskFinishedList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(task,index) in filterByWord" :key="index">
                    <span v-if="task.houseCoverImage" class="cover">
                        <img :src="imageUrl(task.houseCoverImage)" alt="">
                    </span>
                    <div v-else class="cover">
                        <img src="@/assets/img/component/houseCard/default.svg" alt="">
                    </div>
                    <span class="task-date">{{getFormatDate(task.taskBeginTime)}} - {{getFormatDate(task.taskEndTime)}}</span>
                    <span class="house">{{task.houseName}}</span>
                    <span class="name">{{task.taskTakerName}}</span>
                    <span class="pay-way">{{transPayWay(task.paymentType)}}</span>
                    <span class="status">
                        <span class="blue" v-if="task.taskStatus == 4">成功</span>
                        <span class="red" v-if="task.taskStatus == 3 ">被拒絕</span>
                        <span class="gray" v-if="task.taskStatus == 5 ">失敗</span>
                    </span>
                    <span class="bonus">{{toCurrency(task.taskBonus)}}</span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul>
                                <li @click="getViewHouseDetail(task.taskCid,task.taskTakerName), $analyticsBiz.logEvent('看屋明細', { screen_name: '看屋明細'})">看屋明細</li>
                                <li @click="modalStatus.deleteTask = true, taskHouseName = task.houseName, taskId = task.taskCid">刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import Modal from '@/components/widge/Modal.vue';
import ViewHouseDetail from '@/components/bussiness/widges/modals/viewHouseDetail.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'

import { 
    apiBizGetTaskFinished,
    apiBizDeleteTask
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            componentKey: 0,
            taskId: null,
            takerName: null,
            taskHouseName: null,
            // taskFinishedList: [],
            // filterWord: '',
            filterEmpty: false,
            taskFinishedDataEmpty: false,
            taskFinishedDataError: false,
            alarm: false,   
            deleteId: '',
            isDefault: false,
            isLoading: true,
            modalStatus: {
                deleteTask: false
            },
        }
    },
    mounted () {
        this.$store.dispatch('getBizTaskDoneMgtList', 1)
        .then(()=>{
            this.isLoading = false
        })
        // this.getTaskFinishedList()
    },
    watch: {
        totalPage: function (page) {
            if(page > 1){
                for (let i = 2; i <= page; i++) {
                    this.$store.dispatch('getBizTaskDoneMgtList', i)
                }
            }
        }
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false
        },
        closeModal: function (type) {
            this.alarm = false
        },
        openModal: function () {
            this.alarm = true
            this.deleteId = event.target.dataset.id
        },
        transPayWay: function (value) {
            if( value == 'WALLET' ){
                return '飛豬錢包'
            }else if( value == 'TRANSFER' ) {
                return '匯款轉帳'
            }else if( value == 'TASK_REFUND' ) {
                return '系統退款'
            }else if( value == 'DEPOSIT_FORFEIT' ) {
                return '訂金補償'
            }
        },
        setFilterWord: function (value) {
            this.isDefault = false
            this.filterWord = value
        },
        setFilterDefault: function () {
            this.$store.dispatch('setBizTaskDoneMgtFilterDefault')
        },
        // getTaskFinishedList: function () {
        //     apiBizGetTaskFinished()
        //     .then(res => {
        //         console.log(res)
        //         // if( res.data.status == "SUCCESS" ){
        //         //     this.taskFinishedList = res.data.result.houseTaskVoList
        //         // }
        //         if( res.data.status == "SUCCESS" ){
        //             this.totalPage = res.data.result.totalPage
        //             res.data.result.houseTaskVoList.map( item => {
        //                 this.taskFinishedList.push(item) 
        //             })
        //         }
        //     })
        //     .catch(err => {
        //         reject(err)
        //     })
        // },
        getViewHouseDetail: function (id, taker) {
            this.componentKey += 1         
            this.taskId = id
            this.takerName = taker
            document.getElementsByClassName('biz-task-management')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizViewHouse'})
        },
        deleteTask: function () {
            let data = {
                "taskCid": this.taskId
            }
            apiBizDeleteTask(data)
            .then( res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.getTaskFinishedList()
                    this.modalStatus.deleteTask = false
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        imageUrl: function (url){
            return constant.imageUrl+url
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        filterByGroup: function () {
            return this.taskFinishedList.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.salesName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByStatus: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.status){
                    if(item.taskStatus == this.filterQuery.status ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByPayway: function () {
            return this.filterByStatus.filter((item) => {
                if(this.filterQuery.payway){
                    if(item.paymentType == this.filterQuery.payway ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByBonus: function () {
            return this.filterByPayway.filter((item) => {
                if( this.filterQuery.bonus ){
                    if( this.filterQuery.bonus[1] >= 100000){
                        if( this.filterQuery.bonus[0] <= item.taskBonus){
                            return item
                        }
                    }else{
                        if( this.filterQuery.bonus[0] <= item.taskBonus && this.filterQuery.bonus[1] >= item.taskBonus ){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByBonus.filter((item) => {
                if( this.filterWord ){
                    if( item.houseName.includes(this.filterWord) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            taskFinishedList: 'GET_BIZ_TASK_DONE_MGT_LIST',
            totalPage: 'GET_BIZ_TASK_DONE_MGT_TOTAL_PAGE',
            filterQuery: 'GET_BIZ_TASK_DONE_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_TASK_DONE_MGT_FILTER_WORD'
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        RentSelect,
        TableSearch,
        ViewHouseDetail,
        tableLoading
    }
}
</script>
<style lang="scss" scoped>
    .biz-task-finished{
        #modal.delete-task{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #676362;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .table-list-title .cover,
        .table-list-body ul li .cover{
            position: relative;
            width: 127px;
            margin-right: 48px;
        }
        .table-list-title .task-date,
        .table-list-body ul li .task-date{
            width: 160px;
            margin-right: 43px;
        }
        .table-list-title .house,
        .table-list-body ul li .house{
            width: 200px;
            margin-right: 45px;
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 56px;
            margin-right: 45px;
        }
        .table-list-title .pay-way,
        .table-list-body ul li .pay-way{
            width: 58px;
            margin-right: 45px;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 76px;
            margin-right: 45px;
        }
        .table-list-title .bonus,
        .table-list-body ul li .bonus{
            text-align: right;
            width: 58px;
            margin-right: 45px;
        }
        .table-list-body .cover{
            width: 120px;
            height: 90px;
            border-radius: 4px;
            margin-right: 16px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            >img{
                width: 100%;
            }
        }
        .table-list-body ul li .status{
            >span{
                width: 76px;
                height: 38px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .blue{
                background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
        }
    }
    // @media screen and (max-width: 1280px){
    //     .task-finished{
    //         .table-list-title .cover,
    //         .table-list-body ul li .cover{
    //             margin-right: 45px;
    //         }
    //         .table-list-title .task-date,
    //         .table-list-body ul li .task-date{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .house,
    //         .table-list-body ul li .house{
    //             margin-right: 45px;
    //         }
    //         .table-list-title .name,
    //         .table-list-body ul li .name{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .pay-way,
    //         .table-list-body ul li .pay-way{
    //             margin-right: 46px;
    //         }
    //         .table-list-title .status,
    //         .table-list-body ul li .status{
    //             margin-right: 46px;
    //         }
    //         .table-list-title .bonus,
    //         .table-list-body ul li .bonus{
    //             margin-right: 46px;
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/taskMgt/taskDone/taskDoneList.vue